// Il marchio J disegnato in vettoriale direttamente nella pagina.
//
// Perche' non il PNG: in testata il logo e' alto 58px, e a quella misura le
// onde del file raster diventavano larghe 1,8px l'una — quattro archi sottili
// vicini che lo schermo impasta in un alone scuro, come se un velo coprisse
// la parte alta del marchio. Qui i tratti sono ricalibrati per le misure
// piccole: onde a 26 invece di 16, e il disegno resta nitido a ogni densita'
// di schermo. Il PNG pieno (public/brand/) resta per stampa e usi esterni.
function JammoMark({ height = 58, color = '#ED4D1D', ...rest }) {
  return (
    <svg viewBox="0 0 512 512" width={height} height={height} fill="none"
      stroke={color} strokeLinecap="round" role="img" aria-label="Jammo" {...rest}>
      <circle cx="311" cy="90" r="46" fill={color} stroke="none"/>
      <path d="M311 200 L311 346 A100 100 0 0 1 111 346" strokeWidth="88"/>
      <path d="M377 38 A84 84 0 0 1 377 142" strokeWidth="26"/>
      <path d="M421 32 A124 124 0 0 1 421 148" strokeWidth="26"/>
      <path d="M245 38 A84 84 0 0 0 245 142" strokeWidth="26"/>
      <path d="M201 32 A124 124 0 0 0 201 148" strokeWidth="26"/>
    </svg>
  );
}

export default JammoMark;
